import React from "react";
import { motion } from "framer-motion";
import { PageHero, Reveal, SectionHeader, CTABanner, EditorialMarquee } from "@/components/ui-blocks";
import { StatsBar } from "@/components/sections";

const LETTER = [
  "We would like to take a moment of your time to introduce ourselves. We are PHOS Management — a knowledgeable building and remodeling company. We have been in the building business for over 25 years and have put together a company that can fulfill all your residential and commercial needs.",
  "We strive for excellence and want all our customers to be satisfied with the work we perform. If you have any questions or need more information, please contact us using the form in the Contact section of this site. We would be happy to provide whatever you need.",
  "With the residential part of our company, we can meet all your needs inside and out — from kitchen and bathroom to siding, decks, and cement — as well as several apartment complexes, student housing, and businesses. From roofing, siding, cement, and masonry — keep us in mind for your next building project. It would be our pleasure.",
];

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHero
        eyebrow="About PHOS Management"
        title={["Built on", "integrity", "and 25 years", "of doing."]}
        sub="A knowledgeable building and remodeling company serving Southeast Michigan for over 25 years — residential and commercial, inside and out."
        image="/brand/placeholder.jpg"
        alt="PHOS Management on-site"
      />

      <StatsBar />

      <EditorialMarquee items={["Integrity", "Craftsmanship", "Safety", "Communication", "On-Time"]} />

      {/* Letter from PHOS */}
      <section data-testid="about-letter" className="relative py-24 lg:py-40">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <SectionHeader eyebrow="A Letter From" title={<>PHOS{"\n"}Management.</>} />
          </div>

          <div className="lg:col-span-7 lg:col-start-6">
            <div className="border-l border-accent pl-6 lg:pl-10 space-y-8">
              {LETTER.map((para, i) => (
                <Reveal key={i} delay={i * 0.08}>
                  <p className="text-ink-200 text-base lg:text-lg leading-relaxed">
                    {para}
                  </p>
                </Reveal>
              ))}

              <Reveal delay={0.3}>
                <div className="pt-6">
                  <p className="text-ink-400 text-base">Thank you,</p>
                  <p className="font-display text-3xl lg:text-4xl uppercase mt-2 text-ink-50">
                    PHOS Management
                  </p>
                  <span className="block w-16 h-px bg-accent mt-6" />
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </section>

      <CTABanner
        eyebrow="Work with us"
        heading={<>Bring us your{"\n"}next project.</>}
        sub="Twenty-five years of experience. One accountable partner. Zero excuses."
      />
    </div>
  );
}
